import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-66109a14")

_pushScopeId("data-v-66109a14")
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "filert-container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "header-name" }, "工作状态：", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  class: "icon",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "#icon-zhuanhuan" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 切换服务器 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 修改 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 同步数据 ")
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_waves = _resolveDirective("waves")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_select, {
        modelValue: _ctx.workState,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.workState = $event)),
        class: "m-2",
        placeholder: "Select"
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toSearch())),
        icon: "el-icon-search"
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.search")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _withDirectives(_createVNode(_component_el_button, {
        class: "filter-item",
        type: "primary",
        icon: "el-icon-refresh",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toReload()))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.reset")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _withDirectives(_createVNode(_component_el_button, {
        type: "primary",
        class: "filter-item",
        icon: "el-icon-plus",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toAdd()))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.t("table.add")), 1)
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ]),
      _withDirectives(_createVNode(_component_el_button, {
        type: "primary",
        class: "filter-item",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toTogger()))
      }, {
        default: _withId(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      }, 512), [
        [_directive_waves]
      ])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.list,
      key: _ctx.tableKey,
      border: "",
      "highlight-current-row": "",
      style: {"width":"100%"}
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, { label: "服务器类型" }, {
          default: _withId(({ row }) => [
            _createTextVNode(_toDisplayString(row.svrtype === '0' ? '交换服务器' : ''), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "ip地址" }, {
          default: _withId(({ row }) => [
            _createTextVNode(_toDisplayString(row.ip), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "DDOS" }, {
          default: _withId(({ row }) => [
            _createTextVNode(_toDisplayString(row.ddosIp), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "创建时间" }, {
          default: _withId(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.time(row.createDate)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "服务器名字" }, {
          default: _withId(({ row }) => [
            _createTextVNode(_toDisplayString(row.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "工作状态" }, {
          default: _withId(({ row }) => [
            _createTextVNode(_toDisplayString(row.workState === 2 ? '正常' : '非正常'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "总容量" }, {
          default: _withId(({ row }) => [
            _createTextVNode(_toDisplayString(row.amount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "剩余容量" }, {
          default: _withId(({ row }) => [
            _createTextVNode(_toDisplayString(row.leftAmount), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "备注" }, {
          default: _withId(({ row }) => [
            _createTextVNode(_toDisplayString(row.remarks), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "260"
        }, {
          default: _withId((scope) => [
            _createVNode(_component_el_button, {
              size: "small",
              onClick: ($event: any) => (_ctx.handleEdit(scope.$index, scope.row))
            }, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_popconfirm, {
              "confirm-button-text": "确定",
              "cancel-button-text": "取消",
              "icon-color": "red",
              title: "你确定删除吗?",
              onConfirm: ($event: any) => (_ctx.handleDelete(scope.row))
            }, {
              reference: _withId(() => [
                _createVNode(_component_el_button, { size: "small" }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onConfirm"]),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: ($event: any) => (_ctx.handleSync(scope.row))
            }, {
              default: _withId(() => [
                _hoisted_8
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]), [
      [_directive_loading, _ctx.listLoading]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogFormdistribute,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.dialogFormdistribute = $event)),
      title: _ctx.title
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.dialogFormdistribute = false))
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submitDisForm()))
          }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: "formdistribute",
          "label-width": "140px",
          rules: _ctx.rulesFormdistribute,
          model: _ctx.form
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: "服务器名字:",
              prop: "name"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.name,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.name = $event)),
                  maxlength: "20",
                  placeholder: "请输入服务器名字"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "ip地址:",
              prop: "ip"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.ip,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.form.ip = $event)),
                  maxlength: "25",
                  placeholder: "请输入ip地址"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "ddos:" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.ddosIp,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.ddosIp = $event)),
                  maxlength: "25"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "总容量:",
              prop: "amount"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.amount,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.amount = $event)),
                  maxlength: "12",
                  placeholder: "请输入总容量"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "工作状态:" }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.workState,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.workState = $event)),
                  class: "m-2",
                  placeholder: "Select"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注:",
              prop: "remarks"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.remarks,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.remarks = $event)),
                  maxlength: "250"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogFormtoggle,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.dialogFormtoggle = $event)),
      title: _ctx.title,
      width: "30%"
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.dialogFormtoggle = false))
          }, {
            default: _withId(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.submitDisToggle()))
          }, {
            default: _withId(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode(_component_el_form, {
          ref: "formToggle",
          "label-width": "140px",
          rules: _ctx.rulesFormToggle,
          model: _ctx.toggle
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: "账号:",
              style: {"max-width":"21.7rem"}
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.toggle.loginName,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.toggle.loginName = $event)),
                  onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handelSelectAdminIp()))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "原服务器ip:",
              prop: "oldIp"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.toggle.oldIp,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.toggle.oldIp = $event)),
                  class: "m-2"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "新服务器ip:",
              prop: "newIp"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.toggle.newIp,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.toggle.newIp = $event)),
                  class: "m-2",
                  placeholder: "Select"
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.ip,
                        label: item.ip,
                        value: item.ip
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
})